import { RequestResetPwdType } from "./_model"
import { API_URLs } from "../../../../utilities/API_URLs"
import iAxios from "../../../../utilities/axios/axios-setup"

export const getResetPasswordToken = (data: RequestResetPwdType) => {
  return iAxios.post(API_URLs.auth.postForgetPwd, data)
  .then(res => {
    return {success: 'OK'}
  })
  .catch(e => {
    return e
  })
}

export const updatePassword = (data: {token: string; password: string}) => {
  return iAxios.post(API_URLs.auth.postForgetPwd + data.token, {password: data.password})
  .then(res => {
    return {success: 'OK'}
  })
  .catch(e => {
    return e
  })
}